import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { devices } from '@vr/lib/styles/theme';
import { useDispatch, useSelector } from 'react-redux';
import { ToastCtx } from '~/providers/ToastProvider';
import UserDataForm from '../../components/forms/UserDataForm';
import { Logo as DefaultLogo, H2 } from '../../elements';
import { Loader } from '../../components';
import { recaptchaRequest } from '~/store/modules/recaptcha/actions';
import { toggleLoading } from '~/store/modules/loading/actions';
import messages from '~/helpers/api/messages';

const Container = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 32px;
  box-sizing: border-box;

  .back {
    display: flex;
    justify-content: center;
  }
`;

const Title = styled(H2)`
  margin-bottom: 35px;
  text-align: center;
`;

const Logo = styled(DefaultLogo)`
  display: none;

  @media (min-width: ${devices?.desktop}) {
    position: absolute;
    left: 64px;
    top: 21px;
    display: block;
  }
`;

const Cadastro = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const logo = useSelector(state => state?.issuer?.logo);
  const [isLoading, setIsLoading] = useState(false);
  const { siteKey } = useSelector(state => state.recaptcha);

  const toast = useContext(ToastCtx);

  async function getReCaptchaKey() {
    try {
      dispatch(recaptchaRequest());

      dispatch(toggleLoading(true));
    } catch (e) {
      toast.dispatch(messages(e, 'recaptcha'));
    } finally {
      dispatch(toggleLoading(false));
    }
  }

  useEffect(() => {
    if (!siteKey) {
      getReCaptchaKey();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <Logo alt={logo?.alt} src={logo?.src} />
      <Title color="white">Cadastre-se</Title>
      <Loader isLoading={isLoading}>
        <UserDataForm
          onSave={() => history.push('/login')}
          setIsLoading={setIsLoading}
          isLoading={isLoading}
          recaptcha
        />
      </Loader>
    </Container>
  );
};

Cadastro.defaultProps = {
  theme: {},
};

export default Cadastro;
